/* Container */
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;

  font-family: 'Onest', sans-serif;
  font-size: 16px;
  color: #505050;
  line-height: 1.5;
}

/* Hero */
.pageHero {
  background-color: #fffdf7;
  padding: 70px 0 0 0;
  text-align: center;
}

.title {
  font-size: 2rem;
  font-weight: 400;
  margin: 0 0 8px 0;
  color: #505050;
}

.subtitle {
  font-size: 1.2rem;
  color: #505050;
  max-width: 800px;
  margin: 0 auto;
  font-weight: 200;
}

/* Main section: center everything */
.contactSection {
  padding: 20px 0;
}

/* Columns wrapper: center its content */
.contactColumns {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
}

/* Card */
.contactFormWrapper {
  width: 100%;
  max-width: 600px;
  padding: 32px;
  border-radius: 10px;
  corner-shape: superellipse(1.18);

  display: flex;
  justify-content: center;
  align-items: stretch;
  box-sizing: border-box;
}

.contactForm {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* inputs */
.contactForm input,
.contactForm textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  corner-shape: superellipse(1.18);
  font-size: 1rem;
  font-family: 'Onest', sans-serif;
  color: #505050;
  box-sizing: border-box;
}

.buttonContainer {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.error {
  color: #d32f2f;
  font-size: 12px;
  margin-top: 4px;
}

/* Responsive */
@media (max-width: 768px) {
  .contactFormWrapper {
    max-width: 520px;
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .pageHero {
    padding: 40px 0 0 0;
  }

  .contactSection {
    padding: 10px 0;
  }

  .contactFormWrapper {
    padding: 12px;
    max-width: 100%;
  }
}
